import BuildIcon from "@mui/icons-material/Build"
import ExtensionIcon from "@mui/icons-material/Extension"
import InventoryIcon from "@mui/icons-material/Inventory"
import ScienceIcon from "@mui/icons-material/Science"
import { DeviceType } from "graphql/types"

export const getDeviceTypeColor = (type: DeviceType) => {
  switch (type) {
    case DeviceType.EQUIPMENT_UNDER_TEST:
      return "#4CAF50" // Green
    case DeviceType.EUT_GROUP:
      return "#4CAF50" // Green
    case DeviceType.TEST_EQUIPMENT:
      return "#2196F3" // Blue
    case DeviceType.CONSUMABLE:
      return "#FF9800" // Orange
    case DeviceType.AUX:
      return "#9C27B0" // Purple

    default:
      return "#607D8B" // Gray
  }
}

export const getDeviceTypeIcon = (type: DeviceType) => {
  switch (type) {
    case DeviceType.EQUIPMENT_UNDER_TEST:
      return <BuildIcon fontSize="small" />
    case DeviceType.TEST_EQUIPMENT:
      return <ScienceIcon fontSize="small" />
    case DeviceType.CONSUMABLE:
      return <InventoryIcon fontSize="small" />
    case DeviceType.AUX:
      return <ExtensionIcon fontSize="small" />
    case DeviceType.EUT_GROUP:
      return <BuildIcon fontSize="small" />
    default:
      return undefined
  }
}
